import { useServiceClient } from 'bz-stores/hooks/service-client';
import { OnlinePublicRemoveTempFile } from 'tm3-core/api.dtos';

export const useRemoveTempFile = () => {
  const client = useServiceClient();

  return async (folderId: string, fileName: string): Promise<void> => {
    await client.delete(new OnlinePublicRemoveTempFile({ id: folderId, fileName }));
  };
};
